import {
  createParser,
  useQueryState,
} from "nuqs";

import {
  decodeSkuKeyDict,
  encodeSkuKeyDict,
} from "@/shared.utils/products";

/**
 * SPECS:
 * - Value will be stored in object with key as variantKey and value as optionKey
 * - variantKey will be exectly 2 chars long
 * - optionKey will be exectly 3 chars long
 *
 * Example:
 * Value: {
 *   "Aa": "a3q",
 *   "Bb": "oe3",
 * }
 *
 * QueryString: Aaa3qBbboe3
 */

type VariantState = Record<string, string>;

export const parseVariantState = (queryString: string): VariantState => {
  const variants = decodeSkuKeyDict(queryString);
  return variants;
};

export const serializeVariantState = (variants: VariantState): string => {
  const queryString = encodeSkuKeyDict(variants);
  return queryString;
};

export const parseAsVariantState = createParser<VariantState>({
  parse: parseVariantState,
  serialize: serializeVariantState,
});

export const useVariantState = () => {
  const [opts, setOpts] = useQueryState(
    "opts",
    parseAsVariantState,
  );

  const getVal = (variantKey: string) => {
    return opts?.[variantKey];
  };

  const setVal = (variantKey: string, optionKey: string) => {
    setOpts(((oldVal) => {
      return {
        ...oldVal,
        [variantKey]: optionKey,
      };
    }));
  };

  return {
    getVal,
    opts,
    setOpts,
    setVal,
  };
};
